var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPointsCel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 111,
    viewBox: "0 0 110 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M67.4283 75.1491L68.7298 76.1337L68.2032 74.589L63.0997 59.6208L73.7818 51.5289L74.968 50.6304H73.4799H60.0377L55.4732 37.249L54.9999 35.8617L54.5267 37.249L49.9623 50.6304H36.52H35.0319L36.218 51.5289L46.9001 59.6208L41.7967 74.589L41.27 76.1337L42.5716 75.1491L54.9999 65.7473L67.4283 75.1491ZM62.2667 47.0217L62.3821 47.3604H62.7399H84.7414L67.2682 60.5917L66.9802 60.8098L67.0967 61.1517L75.2998 85.2159L55.3118 70.0818L55.01 69.8533L54.7082 70.0817L34.71 85.2166L42.9133 61.1517L43.0298 60.8097L42.7417 60.5917L25.2591 47.3604H47.2499H47.6076L47.7231 47.0219L54.9996 25.6994L62.2667 47.0217Z",
    fill: "#15264C",
    stroke: "#15264C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.81 55.3702C4.81 83.0563 27.3237 105.57 54.9999 105.57C82.6761 105.57 105.19 83.0563 105.19 55.3702C105.19 27.694 82.6761 5.18018 54.9999 5.18018C27.3238 5.18018 4.81 27.694 4.81 55.3702ZM0.809998 55.3702C0.809998 25.4463 25.0661 1.18018 54.9999 1.18018C84.9337 1.18018 109.19 25.4463 109.19 55.3702C109.19 85.304 84.9239 109.56 54.9999 109.56C25.0661 109.56 0.809998 85.304 0.809998 55.3702Z",
    fill: "#15264C",
    stroke: "#15264C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPointsCel);
export default __webpack_public_path__ + "static/media/points-cel.3900d991c218720c223b5d40579567f9.svg";
export { ForwardRef as ReactComponent };